import API from '@/api/apiUrls'
import { useApi } from '@/api/useApi'
import { useSearchUserBaseStore } from '@haskoning/vue-basestore'
import { defineStore } from 'pinia'
import { type Ref, ref } from 'vue'
import type { UserType } from '@/stores/type/user.type'

const api = useApi<UserType>()
const currentUser = API.USER.CURRENT_USER
const userIndex = API.USER.BASE

export const useAuthenticationStore = defineStore('authentication', () => {
	const userBaseStore = useSearchUserBaseStore<UserType>(api, userIndex)
	const user: Ref = ref<UserType | null>(null)

	const authenticate = async ({ email, password }: { email: string; password: string }) => {
		await api.apiService.authenticationHandler.authenticate(email, password)
		const userResponse = await api.service(currentUser).get()
		user.value = userResponse
		return { user: userResponse }
	}

	const reAuthenticate = async () => {
		await api.apiService.authenticationHandler.setAccessTokenInHeaderFromStore()
		try {
			const userResponse = await api.service(currentUser).get()
			user.value = userResponse
			return userResponse
		} catch (e) {
			user.value = null
			return null
		}
	}

	const logout = () => {
		localStorage.removeItem('access')
		localStorage.removeItem('refresh')
		user.value = null
	}

	return {
		...userBaseStore,
		user,
		authenticate,
		reAuthenticate,
		logout
	}
})
